(() => {
	/** @type {HTMLAnchorElement[]} */
	const linkIcons = Array.from(document.querySelectorAll("section[id] a.js-link"));

	for (const linkIcon of linkIcons) {
		const id = linkIcon.closest("section[id]").id;
		const url = `${window.location.origin}${window.location.pathname}#${id}`;
		linkIcon.href = url;
	}
})();